<script>
import ApiTenantService from "@/services/api/ApiTenantService";
import { mapActions } from "vuex";

export default {
  name: "BookableLockingAttributes",
  props: {
    tenantId: {
      type: String,
      required: true,
    },
    amount: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      lockerSystems: [],
    };
  },
  computed: {
    lockerDetails: {
      get() {
        return this.$store.state.bookables.form.lockerDetails;
      },
      set(value) {
        this.updateValue({ field: "lockerDetails", value });
      },
    },
    lockerUnitCount: {
      get() {
        return Number(
          this.lockerDetails.units
            ?.map((unit) => unit.amount)
            ?.reduce((acc, val) => acc + val, 0)
        );
      },
    },
  },
  methods: {
    ...mapActions({
      updateValue: "bookables/updateForm",
    }),
    async fetchLockerSystems() {
      try {
        const tenant = await ApiTenantService.getTenant(this.tenantId);
        this.lockerSystems = tenant.data.applications?.filter(
          (app) => app.type === "locker" && app.active
        );
      } catch (error) {
        console.error(error);
      }
    },
    addLockerUnit() {
      const details = this.lockerDetails || {};
      const units = Array.isArray(details.units) ? [...details.units] : [];
      units.push({ id: "", lockerSystem: "", amount: 1 });
      this.lockerDetails = {
        ...details,
        units,
      };
    },
    removeLockerUnit(idx) {
      this.lockerDetails.units.splice(idx, 1);
    },
  },
  mounted() {
    this.fetchLockerSystems();
  },
};
</script>

<template>
  <div>
    <v-row>
      <v-col>
        <v-expansion-panels flat multiple>
          <v-expansion-panel class="mb-6 panel">
            <v-expansion-panel-title
              color="accent"
              expand-icon="mdi-menu-down"
              class="panel-header"
            >
              <template v-slot:default="{ expanded }">
                <v-row no-gutters align="center">
                  <v-col cols="4">
                    <span class="text-subtitle-1"> Schließsysteme </span>
                  </v-col>
                  <v-col cols="2">
                    <v-fade-transition leave-absolute>
                      <div v-if="!expanded">
                        <v-icon color="darkgrey">mdi-information</v-icon>
                        <span v-if="lockerDetails.active" class="ml-2"
                          >Aktiviert</span
                        >
                        <span v-else class="ml-2">Inaktiviert</span>
                      </div>
                    </v-fade-transition>
                  </v-col>
                  <v-col cols="4" offset="1" class="text--secondary r-offset">
                    <v-fade-transition leave-absolute>
                      <v-alert
                        type="warning"
                        density="compact"
                        variant="outlined"
                        v-if="
                          lockerDetails.active && lockerUnitCount !== amount
                        "
                      >
                        Die Anzahl der verfügbaren Buchungsobjekte passt nicht
                        mit der Anzahl der Schließfächer überein.
                      </v-alert>
                    </v-fade-transition>
                  </v-col>
                </v-row>
              </template>
            </v-expansion-panel-title>
            <v-expansion-panel-text>
              <v-row>
                <v-col>
                  <v-switch
                    v-model="lockerDetails.active"
                    label="Schließsystem aktivieren"
                  >
                  </v-switch>
                </v-col>
              </v-row>
              <v-row
                v-for="(unit, idx) in lockerDetails.units"
                :key="idx"
                align="center"
              >
                <v-col cols="12" md="4">
                  <v-select
                    bg-color="accent"
                    variant="filled"
                    v-model="unit.lockerSystem"
                    :items="lockerSystems"
                    object
                    item-title="title"
                    item-value="id"
                    label="Schließsystem"
                    hide-selected
                    hide-details
                  >
                  </v-select>
                </v-col>
                <v-col>
                  <v-text-field
                    v-model="unit.id"
                    label="Produkt-ID"
                    bg-color="accent"
                    variant="filled"
                    hide-selected
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    type="number"
                    v-model="unit.amount"
                    label="Anzahl Schließfächer"
                    bg-color="accent"
                    variant="filled"
                    hide-selected
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-tooltip location="bottom">
                  <template v-slot:activator="{ props }">
                    <v-btn
                      v-bind="props"
                      icon
                      variant="text"
                      @click="removeLockerUnit(idx)"
                    >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </template>
                  <span>Schließfach löschen</span>
                </v-tooltip>
              </v-row>
              <v-row>
                <v-col class="text-center">
                  <v-tooltip location="bottom" offset-y>
                    <template v-slot:activator="{ props }">
                      <v-btn
                        class="align-center add-time-period"
                        v-bind="props"
                        variant="outlined"
                        :disabled="!lockerDetails.active"
                        @click="addLockerUnit"
                      >
                        Weitere Schließfach hinzufügen
                      </v-btn>
                    </template>
                    <span>Weitere Schließfach hinzufügen</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-expansion-panel-text>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
  </div>
</template>

<style scoped>
.panel {
  box-shadow: 0 1px 1px rgb(0 0 0 / 0.2);
}
.panel-header {
  padding: 13px 13px 13px 13px;
}
</style>
